<template>
  <div>
    <b-row>
      <b-col xl="12">
        <b-card header="Opciones de Consulta" class="card-filter">
          <b-btn class="filter-collapse" 
              variant="primary" 
              size="sm"
              @click.prevent="showOpcionesFiltro= !showOpcionesFiltro">
            <i :class="showOpcionesFiltro ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
          </b-btn>
          <b-collapse id="filtro" class="mt-2" v-model="showOpcionesFiltro">
            <b-form>
              <b-form-group
                v-if="!impuestos"
                label="Proveedor"
                label-for="proveedor"
                :label-cols="1"
                horizontal>
                <b-input-group v-if="seleccionProveedor">
                  <b-input-group-append 
                      class="filter-search-icons" 
                      @click="seleccionarProveedor">
                    <b-input-group-text>
                    <i :class="{ 'fa fa-search': !filtro.proveedor,
                                  'fa fa-remove': filtro.proveedor  }"></i>
                    </b-input-group-text>
                  </b-input-group-append>
                  <!-- <b-input-group-append 
                      class="filter-search-icons" 
                      @click="cancelarSeleccionProveedor">
                    <b-input-group-text>
                      <i class="fa fa-remove"></i>
                    </b-input-group-text>
                  </b-input-group-append> -->
                  <b-form-input 
                    :value="proveedorSeleccionNombre"
                    readonly
                    type="text"/>
                </b-input-group>
                <b-form-input 
                  :value="proveedorNombre"
                  readonly
                  type="text"
                  v-if="!seleccionProveedor"/>
              </b-form-group>

              <b-form-group
                v-if="impuestos"
                label="Impuesto"
                label-for="proveedor"
                :label-cols="1"
                horizontal>
                <b-input-group v-if="seleccionProveedor">
                  <b-input-group-append 
                      class="filter-search-icons" 
                      @click="seleccionarImpuesto">
                    <b-input-group-text>
                    <i :class="{ 'fa fa-search': !filtro.proveedor,
                                  'fa fa-remove': filtro.proveedor  }"></i>
                    </b-input-group-text>
                  </b-input-group-append>
                  <!-- <b-input-group-append 
                      class="filter-search-icons" 
                      @click="cancelarSeleccionImpuesto">
                    <b-input-group-text>
                      <i class="fa fa-remove"></i>
                    </b-input-group-text>
                  </b-input-group-append> -->
                  <b-form-input 
                    :value="proveedorSeleccionNombre"
                    readonly
                    type="text"/>
                </b-input-group>
                <b-form-input 
                  :value="proveedorNombre"
                  readonly
                  type="text"
                  v-if="!seleccionProveedor"/>
              </b-form-group>

              <b-form-group
                label="Desde"
                :label-cols="1"
                horizontal>
                <b-input-group>
                  <b-form-input 
                    v-model= "filtro.fechaDesde" 
                    type="date"
                    v-if="seleccionProveedor">
                  </b-form-input>
                  <b-form-input 
                    :value= "fechaDesdeSeleccionada | fecha" 
                    readonly
                    type="text"
                    v-if="!seleccionProveedor">
                  </b-form-input>
                </b-input-group>
              </b-form-group>

              <b-form-group
                label="Hasta"
                :label-cols="1"
                horizontal>
                <b-input-group>
                  <b-form-input 
                    v-model= "filtro.fechaHasta" 
                    type="date"
                    v-if="seleccionProveedor">
                  </b-form-input>
                  <b-form-input 
                    :value= "fechaHastaSeleccionada | fecha" 
                    readonly
                    type="text"
                    v-if="!seleccionProveedor">
                  </b-form-input>
                </b-input-group>
              </b-form-group>
              <div slot="footer">
                <b-button size="sm" variant="primary" class="footer-button" v-if="!seleccionProveedor"
                  @click.prevent="seleccionarOpciones">Seleccionar</b-button>
                <b-button size="sm" variant="primary" class="footer-button" v-if="seleccionProveedor"
                  @click.prevent="aceptarSeleccion">Aceptar</b-button>
                <b-button size="sm" variant="danger" class="footer-button" v-if="seleccionProveedor"
                  @click.prevent="cancelarSeleccion">Cancelar</b-button>
              </div>
            </b-form>
          </b-collapse>
        </b-card>
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card :header="titulo">
          <b-table hover
              responsive="sm" 
              class="registro"
              :busy="tableBusy"
              :items="cuentaCorriente" 
              :fields="cuentaCorrienteFields">
            <div slot="table-busy" class="text-center">
              <b-spinner variant="primary" label="Spinning" />
            </div>              
            <template v-slot:cell(fechaComprobante)="data">
              {{ data.item.fechaComprobante | fecha }}
            </template>
            <template v-slot:cell(periodo)="data">
              {{ data.item.periodo | periodo }}
            </template>
            <template v-slot:cell(debePesos)="data">
              {{ data.item.debePesos | moneda }}
            </template>
            <template v-slot:cell(haberPesos)="data">
              {{ data.item.haberPesos | moneda }}
            </template>
            <template v-slot:cell(saldoAcumuladoPesos)="data">
              {{ data.item.saldoAcumuladoPesos | moneda }}
            </template>
            <template v-slot:cell(debeDolares)="data">
              {{ data.item.debeDolares | moneda('usd') }}
            </template>
            <template v-slot:cell(haberDolares)="data">
              {{ data.item.haberDolares | moneda('usd') }}
            </template>
            <template v-slot:cell(saldoAcumuladoDolares)="data">
              {{ data.item.saldoAcumuladoDolares | moneda('usd') }}
            </template>

            <template v-slot:cell(importe)="data">
              {{ data.item.importe | moneda }}
            </template>
            <template v-slot:cell(saldo)="data">
              {{ data.item.saldo | moneda }}
            </template>
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <div class="fixed-btn" v-if="!impuestos">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item
              @click.stop="exportXls">
            <i class="fa fa-file-excel-o"></i>Exportar Resumen</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <b-modal ref="searchProveedorModal" 
        title="Seleccionar Proveedor"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="proveedores-search-modal">
      <app-search-proveedor
        :incluirInactivos="true"
        @proveedorSeleccionado="proveedorSeleccionado">
      </app-search-proveedor>  
    </b-modal>

    <b-modal ref="searchImpuestoModal" 
        title="Seleccionar Impuesto"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="proveedores-search-modal">
      <app-search-impuesto
        @impuestoSeleccionado="impuestoSeleccionado">
      </app-search-impuesto>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      :modalVariant="modalVariant"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import SearchProveedor from '../proveedores/SearchList.vue'
import SearchImpuesto from '../impuestos/SearchList.vue';
import export_xls_cuenta_corriente from '../../mixins/export_xls_cuenta_corriente';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'cuentacorrienteproveedores/getField',
  mutationType: 'cuentacorrienteproveedores/updateField',
});

export default {
  name: 'CuentaCorrienteProveedores',
  components: {
    appSearchProveedor: SearchProveedor,
    appSearchImpuesto: SearchImpuesto,
    appMensaje: Mensaje
  },
  mixins: [ 
    msjModal, 
    export_xls_cuenta_corriente
  ],
  props: {
    impuestos: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      cuentaCorrienteFields: [
        {
          key: 'fechaComprobante',
          label: 'Fecha Comp.'
        },
        { 
          key: 'comprobanteTipo',
          label: 'Tipo de Comp.' 
        },
        { 
          key: 'comprobanteNumero',
          label: 'Número' 
        },
        {
          key: 'debePesos',
          label: 'Debe - $',
          class: 'text-right'
        },
        {
          key: 'haberPesos',
          label: 'Haber - $',
          class: 'text-right'
        },
        {
          key: 'saldoAcumuladoPesos',
          label: 'Saldo - $',
          class: 'text-right'
        },
        {
          key: 'debeDolares',
          label: 'Debe - usd',
          class: 'text-right'
        },
        {
          key: 'haberDolares',
          label: 'Haber - usd',
          class: 'text-right'
        },
        {
          key: 'saldoAcumuladoDolares',
          label: 'Saldo - usd',
          class: 'text-right'
        },
      ],

      tableBusy: false,
      loaded: false,
      showOpcionesFiltro: false,
      seleccionProveedor: false,

      filtro: {
        proveedor: null,
        fechaDesde: '',
        fechaHasta: ''
      }
    }
  },
  computed: {
    ...mapFields([
      'cuentaCorriente',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
      'fechaDesde',
      'fechaHasta',
      'proveedor',
    ]),
    titulo() {
      if ((/true/i).test(this.impuestos)) {
        return this.proveedor ? 'Estado del Impuesto - ' + this.proveedor.nombre.trim() : '';
      }
      return this.proveedor ? 'Cuenta Corriente del Proveedor - ' + this.proveedor.nombre.trim() : 'Cuenta Corriente';
    },
    proveedorNombre() {
      return this.proveedor ? this.proveedor.nombre : '';
    },
    fechaDesdeSeleccionada() {
      return this.proveedor ? this.fechaDesde : '1900-01-01';
    },
    fechaHastaSeleccionada() {
      return this.proveedor ? this.fechaHasta : '1900-01-01';
    },
    proveedorSeleccionNombre() {
      return this.filtro.proveedor ? this.filtro.proveedor.nombre : '';
    }
  },
  created() {
    if ((/true/i).test(this.impuestos)) {
      this.cuentaCorrienteFields = [
        {
          key: 'fechaComprobante',
          label: 'Fecha Comp.'
        },
        {
          key: 'periodo',
        },
        // { 
        //   key: 'comprobanteNumero',
        //   label: 'Número' 
        // },
        {
          key: 'importe',
          label: 'Importe',
          class: 'text-right'
        },
        {
          key: 'saldo',
          class: 'text-right'
        },
        // {
        //   key: 'saldoAcumulado',
        //   label: 'Saldo',
        //   class: 'text-right'
        // },
      ]
    }

    if (!this.proveedor) {
      this.showOpcionesFiltro = true;
    }
    this.getItems();
  },  
  methods: {
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('cuentacorrienteproveedores/getCuentaCorriente', this.impuestos)
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },
    seleccionarOpciones () {
      this.filtro.proveedor = this.proveedor;
      this.filtro.fechaDesde = this.fechaDesde;
      this.filtro.fechaHasta = this.fechaHasta;
      this.seleccionProveedor = true;
    },

    seleccionarProveedor() {
      if (this.filtro.proveedor) {
        this.filtro.proveedor = null;
      } else {
        this.$refs.searchProveedorModal.show();
      }
    },
    // cancelarSeleccionProveedor() {
    //   this.filtro.proveedor = null;
    // },
    proveedorSeleccionado(item) {
      this.$refs.searchProveedorModal.hide();
      this.filtro.proveedor = item;
    },

    seleccionarImpuesto() {
      if (this.filtro.proveedor) {
        this.filtro.proveedor = null;
      } else {
        this.$refs.searchImpuestoModal.show();
      }
    },
    // cancelarSeleccionImpuesto() {
    //   this.filtro.proveedor = null;
    // },
    impuestoSeleccionado(item) {
      this.$refs.searchImpuestoModal.hide();
      this.filtro.proveedor = item;
    },

    aceptarSeleccion() {
      this.fechaDesde = this.filtro.fechaDesde;
      this.fechaHasta = this.filtro.fechaHasta;
      this.proveedor = this.filtro.proveedor;
      this.seleccionProveedor = false;
      this.paginaActual = 1;
      this.getItems();
    },
    cancelarSeleccion() {
      this.seleccionProveedor = false;
    },
    exportXls () {
      this.showSpinner();
      this.$store.dispatch('cuentacorrienteproveedores/getRptCuentaCorriente')
        .then(() => {
          let exportRpt = Boolean(false); 
          let rptCuentaCorriente = this.$store.getters['cuentacorrienteproveedores/rptCuentaCorriente'];

          if (rptCuentaCorriente) {
            if (rptCuentaCorriente.length != 0) {
              exportRpt = Boolean(true);
            }
          }
          if (exportRpt) {
            let params = {
              label: 'Proveedor',
              nombreComercial: this.proveedorNombre,
              fechaDesde: this.fechaDesdeSeleccionada,
              fechaHasta: this.fechaHastaSeleccionada,
              cuentaCorriente: rptCuentaCorriente
            }

            this.exportXLSRptCuentaCorriente(params);
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light');
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    }
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems();
      }
    },    
  }    
}
</script>

<style>
</style>
